import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import landingFooterImage from "../../assets/images/landing-footer.png";
import landingText from "../../assets/images/parent-zone/logo.png";
import { CloseButton } from "../components/CloseButton";
import { Links } from "../Links";
import { AppMode } from "../../AppMode";

export interface ParentZoneScreenProps
{
}

interface ParentZoneScreenState 
{
}

export class ParentZoneScreen extends Component<ParentZoneScreenProps, ParentZoneScreenState>
{
    constructor(props: ParentZoneScreenProps)
    {
        super(props);

        this.state = {
        };
    }

    private onCloseClicked(): void 
    {
        App.I.changeScreen(AppScreen.Landing);
    }

    public render(): JSX.Element
    {
        return (
            <>
                <CloseButton onClicked={this.onCloseClicked.bind(this)} />

                <div className="parent-zone-screen">
                    <div className="parent-zone-header">
                    </div>

                    <div className="text">
                        <img src={landingText} alt="Fun & games with Mr.Adventure & Little Miss Explorer" />
                    </div>

                    <div className="menu-items-container">
                        <div className="container">
                            <div className="menu-title text-center">
                                <h1 className="text-uppercase">Parent Zone</h1>
                                <p>Services to help you and your family</p>
                            </div>

                            <div className="menu-items">
                                {App.I.appMode === AppMode.Departures ?
                                    <div className="item">
                                        <button className="btn btn-menu" title="Play areas" onClick={() => App.I.openPageInNewTab(App.I.appLinks.linkPlayArea())}>
                                            Play areas
                                            <span className="icon icon-map"></span>
                                        </button>
                                    </div>
                                    : null
                                }

                                <div className="item">
                                    <button className="btn btn-menu" title="Baby changing facilities" onClick={() => App.I.loadIframeUrl(App.I.appLinks.linkBabyChanging())}>
                                        Baby changing facilities
                                        <span className="icon icon-map"></span>
                                    </button>
                                </div>

                                {App.I.appMode === AppMode.Departures ?
                                    <div className="item">
                                        <button className="btn btn-menu" title="Kids eat free" onClick={() => App.I.openPageInNewTab(App.I.appLinks.linkKidsEatFree())}>
                                            Kids eat free
                                            <span className="icon icon-map"></span>
                                        </button>
                                    </div>
                                    : null
                                }

                                <div className="item">
                                    <button className="btn btn-menu" title="Essential shopping" onClick={() => App.I.openPageInNewTab(App.I.appLinks.linkEssentialShopping())}>
                                        Essential shopping
                                        <span className="icon icon-map"></span>
                                    </button>
                                </div>

                                {App.I.appMode === AppMode.Arrivals ?
                                    <div className="item">
                                        <button className="btn btn-menu" title="Heathrow Express" onClick={() => App.I.openPageInNewTab(App.I.appLinks.linkHeathrowExpress())}>
                                            Heathrow Express
                                            <span className="icon icon-map"></span>
                                        </button>
                                    </div>
                                    : null
                                }

                                <div className="item">
                                    <button className="btn btn-menu" title="Safety tips" onClick={() => App.I.changeScreen(AppScreen.EscalatorSafety)}>
                                        Safety tips
                                        <span className="icon icon-info"></span>
                                    </button>
                                </div>


                                <div className="item">
                                    <button className="btn btn-menu" title="Join our mailing list" onClick={() => App.I.openPageInNewTab(App.I.appLinks.linkMailingList())}>
                                        Join our mailing list
                                        <span className="icon icon-info"></span>
                                    </button>
                                </div>

                                <div className="mt-2 p-2 font-secondary">
                                    <p>
                                        Heathrow will not store any images or photographs and do not have access
                                        to any images or photographs associated with this game.
                                    </p>
                                </div>
                                <div className="d-flex ms-auto me-auto mt-auto btn-container">
                                    <button className="btn btn-link" onClick={() => App.I.changeScreen(AppScreen.Landing)}>
                                        Back to home
                                        <i className="bi bi-chevron-right ps-1"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}